import React from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
export function DiscoveryFilters() {
  return <div className="px-6 py-3 bg-navy border-b border-navy-border flex items-center gap-3 text-sm" data-id="element-93">
      <div className="flex items-center text-text-muted mr-2" data-id="element-94">
        <FilterIcon size={14} className="mr-2" data-id="element-95" />
        <span className="font-medium" data-id="element-96">Filter:</span>
      </div>

      <select className="bg-navy-surface border border-navy-border rounded-sm px-2 py-1.5 text-text-primary focus:outline-none focus:border-accent-amber text-xs" data-id="element-97">
        <option data-id="element-98">All Parties</option>
        <option data-id="element-99">Meridian Properties</option>
        <option data-id="element-100">Blackstone Dev.</option>
        <option data-id="element-101">Greenfield Const.</option>
        <option data-id="element-102">Atlas Engineering</option>
      </select>

      <select className="bg-navy-surface border border-navy-border rounded-sm px-2 py-1.5 text-text-primary focus:outline-none focus:border-accent-amber text-xs" data-id="element-103">
        <option data-id="element-104">All Types</option>
        <option data-id="element-105">Interrogatory</option>
        <option data-id="element-106">RFP</option>
        <option data-id="element-107">RFA</option>
      </select>

      <select className="bg-navy-surface border border-navy-border rounded-sm px-2 py-1.5 text-text-primary focus:outline-none focus:border-accent-amber text-xs" data-id="element-108">
        <option data-id="element-109">All Statuses</option>
        <option data-id="element-110">Complete</option>
        <option data-id="element-111">Partial</option>
        <option data-id="element-112">Pending</option>
        <option data-id="element-113">Overdue</option>
      </select>

      <div className="flex-1" data-id="element-114"></div>

      <div className="relative w-64" data-id="element-115">
        <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none" data-id="element-116">
          <SearchIcon size={14} className="text-text-muted" data-id="element-117" />
        </div>
        <input type="text" placeholder="Search questions, responses, tags..." className="bg-navy-surface border border-navy-border rounded-sm pl-8 pr-3 py-1.5 text-text-primary placeholder-text-muted focus:outline-none focus:border-accent-amber w-full text-xs" data-id="element-118" />
      </div>
    </div>;
}